import idKeyFactory from "helpers/idKeyFactory";

export const campaignDropdownListKey = () => ["campaign-dropdown-list"];

export const campaignDropdownListByIdKey = idKeyFactory(campaignDropdownListKey);
